<div class="page-title">Detalhes da assinatura</div>
<div class="details" *ngIf="person && subscriber && subscriber.subscriptionId">
  <div class="details__left" *ngIf="!isMobile">
    <app-person-card
      [person]="person"
      [isMobile]="isMobile"
      [subscriptionId]="subscriber.subscriptionId"
      [influencer]="influencer"
    />
  </div>
  <div class="details__right">
    <div class="card subscriber-info">
      <span class="info">
        <strong
          >Assinatura:
          <span [ngClass]="infoClass(subscriber.subscriptionId)">
            {{ subscriptionName | titlecase }}
          </span>
        </strong>
      </span>
      <span class="info">
        <strong>GlamID</strong>:
        <a
          class="data-link"
          [class.data-link--mens]="mensMarket"
          type="button"
          (click)="copyToClipboard(subscriber.boxId || '')"
        >
          {{ subscriber.boxId || 'N/A' }}
          <i class="pi pi-copy"></i>
        </a>
      </span>
      <span class="info">
        <strong>Plano</strong>:
        {{ subscriptionTypeName || 'Sem plano' | titlecase }}
      </span>
      <span class="info">
        <strong>Status</strong>:
        <span
          class="status change"
          [class.status--active]="subscriber.subscriberStatus === 0"
          [class.status--warning]="
            [10, 11, 12].includes(subscriber.subscriberStatus)
          "
          (click)="
            subscriber.subscriberStatus &&
              ![10, 11, 12].includes(subscriber.subscriberStatus) &&
              statusList &&
              showDropdown()
          "
          *ngIf="!changeStatus && statusList"
        >
          {{ subscriberStatusName }}
        </span>
        <span *ngIf="changeStatus && statusList">
          <p-dropdown
            [options]="statusList"
            optionLabel="status"
            optionValue="subscriberStatusId"
            [formControl]="subscriberStatus"
            (onChange)="changeSubscriberStatus()"
            appendTo="body"
            (onBlur)="changeStatus = false"
            (onHide)="changeStatus = false"
            [autoDisplayFirst]="false"
          >
          </p-dropdown>
        </span>
      </span>
      <span class="info">
        <strong>Desde</strong>
        {{ subscriber.dateCreated | date: 'dd/MM/yyyy' }}
      </span>
      <span class="info">
        <strong>Última atualização</strong>
        {{ subscriber?.dateUpdated | date: 'dd/MM/yyyy HH:mm' }}
      </span>
      <span class="info">
        <strong>Frete</strong>
        {{ address?.shippingPrice || 0 | currency: 'BRL' }}
      </span>
      <span class="info">
        <strong>Próximo ciclo</strong>
        <ng-container *ngIf="subscriber?.nextCycleDate; else noNextCycle">
          {{ subscriber.nextCycleDate | date: 'dd/MM/yyyy' }}
        </ng-container>
        <ng-template #noNextCycle>Não definido</ng-template>
      </span>
      <span class="info">
        <strong>Ciclo início (edição)</strong>
        {{
          subscriber?.cycleStartEdition ??
            subscriber?.startEdition ??
            'Não definido'
        }}
      </span>
      <span class="info">
        <strong>Edição início / fim</strong>
        {{ subscriber?.startEdition ?? '—' }}
        /
        {{ subscriber?.endEdition ?? '—' }}
      </span>
      <span class="info info--full">
        <strong>Endereço de entrega</strong>
        <br />
        <ng-container *ngIf="!address">Sem endereço cadastrado</ng-container>
        <ng-container *ngIf="address">
          {{ address?.street }}
          {{ address?.streetNumber }}
          <span *ngIf="address?.streetExtensions?.length">
            , {{ address.streetExtensions }}
          </span>
          - {{ address?.neighborhood }} {{ address?.city }} -{{
            address?.state
          }}, Brasil CEP {{ address?.postalCode }}
        </ng-container>
      </span>
      <div
        class="payment-summary"
        *ngIf="(paymentHistory && lastPayment) || creditCard || backupCreditCard"
      >
        <p-panel
          header="Forma de pagamento"
          [toggleable]="true"
          [collapsed]="true"
          styleClass="payment-summary__panel"
          *ngIf="!isPix && (creditCard || backupCreditCard || subscriber?.creditCardId)"
        >
          <div class="payment-summary__cards-row">
            <div class="payment-summary__card-slot">
              <h4>Cartão principal</h4>
              <p
                *ngIf="subscriber?.creditCardId"
                class="payment-summary__card-id"
              >
                Credit Card ID: {{ subscriber.creditCardId }}
              </p>
              <app-credit-card-view
                [creditCard]="creditCard"
                *ngIf="creditCard"
              />
              <ng-container *ngIf="!creditCard">
                <i class="pi pi-credit-card"></i>
                <span *ngIf="subscriber?.creditCardId">
                  Cartão {{ subscriber.creditCardId }} não encontrado
                </span>
                <span *ngIf="!subscriber?.creditCardId">Sem cartão</span>
              </ng-container>
            </div>
            <div
              class="payment-summary__card-slot"
              *ngIf="backupCreditCard || backupCreditCardDetail"
            >
              <h4>Cartão de backup</h4>
              <p
                *ngIf="backupCreditCard?.creditCardId"
                class="payment-summary__card-id"
              >
                Credit Card ID: {{ backupCreditCard.creditCardId }}
                <span
                  *ngIf="backupCreditCard.backupCard"
                  class="status status--active"
                  >Backup</span
                >
              </p>
              <app-credit-card-view
                [creditCard]="backupCreditCardDetail || $any(backupCreditCard)"
              />
            </div>
          </div>
        </p-panel>
        <span class="payment-summary__card" *ngIf="isPix">
          <strong>Forma de pagamento</strong>
          <span> <i class="pi pi-qrcode"></i> Pix Automático </span>
          <span *ngIf="lastRecurrence"
            ><strong>Contrato</strong>: {{ lastRecurrence.contrato }}</span
          >
          <span *ngIf="lastRecurrence"
            ><strong>Início</strong>:
            {{ lastRecurrence.dateStart | date: 'dd/MM/yyyy' }}</span
          >
          <p
            *ngIf="lastRecurrence && lastRecurrence?.status !== 'ATIVA'"
            class="status"
            [class.status--progress]="lastRecurrence.status === 'CRIADA'"
          >
            {{ lastRecurrence.status }}
          </p>
        </span>
        <div
          class="payment-summary__last"
          *ngIf="lastPayment"
        >
          <h4>Última cobrança</h4>
          <p>
            <i class="pi pi-clock"></i>
            {{ lastPayment.dateCreated | date: 'dd/MM/yyyy HH:mm' }}
          </p>
          <p>
            <i class="pi pi-dollar"></i>
            {{ lastPayment.amount | currency: 'BRL' }} (em
            {{ lastPayment.installments }}x)
          </p>
          <p
            class="status"
            [class.status--active]="lastPayment.transactionStatusId === 6"
            [class.status--progress]="lastPayment.transactionStatusId === 1"
          >
            {{ lastPayment.transactionStatusName }}
          </p>
        </div>
        <div class="payment-summary__next">
          <h4>Próxima cobrança&nbsp;</h4>
          <p>
            <strong>Next payment:</strong>
            <ng-container *ngIf="subscriber?.nextPaymentDate; else noNextPayment">
              {{ subscriber.nextPaymentDate | date: 'dd/MM/yyyy HH:mm' }}
            </ng-container>
            <ng-template #noNextPayment>Não definido</ng-template>
          </p>
          <p>
            <strong>Next attempt:</strong>
            <ng-container *ngIf="subscriber?.nextAttemptDate; else noNextAttempt">
              {{ subscriber.nextAttemptDate | date: 'dd/MM/yyyy HH:mm' }}
            </ng-container>
            <ng-template #noNextAttempt>Não agendado</ng-template>
            <span class="status" [class.status--active]="recurrenceActive">
              {{ recurrenceStatus }}
            </span>
          </p>
          <p>
            <i class="pi pi-dollar"></i>
            <ng-container *ngIf="subscriber.amount">
              {{ subscriber?.amount | currency: 'BRL' }} (em
              {{ subscriber?.installments || 1 }}x)
            </ng-container>
            <ng-container *ngIf="!subscriber.amount">
              Valor não definido
            </ng-container>
          </p>
          <p *ngIf="!isPix">
            Tentativa: {{ subscriber?.attempt ?? 0 }}/{{
              subscriber?.maxAttempts ?? '—'
            }}
          </p>
        </div>
        <div class="payment-summary__backup" *ngIf="backupCreditCard">
          <h4>Cartão de backup</h4>
          <app-credit-card-view [creditCard]="$any(backupCreditCard)" />
        </div>
      </div>
      <div *ngIf="scheduledCancellation">
        <p class="cancellation-schedule">
          * A assinatura será cancelada a partir de
          {{
            referenceAsDate(scheduledCancellation.cancellationReference)
              | date: 'dd/MM/yyyy'
          }}
        </p>
      </div>
      <div class="buttons" *ngxPermissionsOnly="acceptedPermissions">
        <p-button
          label="Estornar"
          (onClick)="chargeBack()"
          *ngIf="billingsToChargeback?.length"
        />
        <p-button
          label="Cancelar assinatura"
          (onClick)="inactivate()"
          *ngIf="
            ([0, 10].includes(subscriber.subscriberStatus) || frozenRetry) &&
            !scheduledCancellation
          "
        />
        <p-button
          label="Desabilitar recorrência"
          (onClick)="disableRecurrence()"
          *ngIf="subscriber.subscriberStatus === 0 && recurrenceActive"
        />
      </div>
    </div>
    <div class="card">
      <p-tabView
        [activeIndex]="selectedTab"
        (activeIndexChange)="tabChanged($event)"
        *ngIf="pageReady"
      >
        <p-tabPanel [header]="'Edições (' + (oldEditions?.length || 0) + ')'">
          <app-subscriber-compositions
            [lastPayment]="lastSuccessfulPayment"
            [compositions]="compositions"
            [person]="person"
            [isDesktop]="isDesktop"
            [subscriber]="subscriber"
            [subscriptionType]="subscriptionType"
            (editionChanged)="editionChanged()"
          />
        </p-tabPanel>
        <p-tabPanel
          [header]="'Cobranças (' + (paymentHistory?.length || 0) + ')'"
        >
          <div class="payments" *ngIf="paymentHistory">
            <app-table
              [lazy]="false"
              [elements]="paymentHistory"
              [cols]="paymentCols"
              dataKey="paymentId"
              expandField="billings"
              [expansionCols]="billingCols"
              sortField="dateCreated"
              [sortOrder]="1"
              emptyMessage="{{ person.name }} não realizou pagamentos"
              [exportPdf]="false"
              [exportExcel]="false"
              [showTitle]="false"
              [addButton]="false"
              [changeColumns]="true"
              [actionButtons]="actionButtons"
            />
          </div>
        </p-tabPanel>
        <p-tabPanel
          [header]="'Vouchers (' + voucherBillings.length + ')'"
          *ngIf="voucherBillings && voucherBillings?.length"
        >
          <app-table
            [lazy]="false"
            [elements]="voucherBillings"
            [cols]="voucherCols"
            [exportPdf]="false"
            [exportExcel]="false"
            [showTitle]="false"
            [addButton]="false"
            [changeColumns]="true"
            sortField="dateCreated"
            [sortOrder]="1"
          />
        </p-tabPanel>
        <p-tabPanel [header]="'Renovações (' + (renewals?.length || 0) + ')'">
          <app-table
            [cols]="renewalsCols"
            [elements]="renewals"
            sortField="dateCreated"
            [sortOrder]="1"
            [lazy]="false"
            emptyMessage="{{ person.name }} não realizou agendamentos"
            [exportPdf]="false"
            [exportExcel]="false"
            [showTitle]="false"
            [addButton]="false"
            [changeColumns]="true"
          />
        </p-tabPanel>
        <p-tabPanel
          [header]="'Alterações (' + (addressChanges?.length || 0) + ')'"
        >
          <app-table
            [cols]="addressChangeCols"
            [elements]="addressChanges"
            sortField="dateChanged"
            [sortOrder]="1"
            modelName="alteraçoes"
            [exportPdf]="false"
            [exportExcel]="false"
            [showTitle]="false"
            [addButton]="false"
            [changeColumns]="true"
            [lazy]="false"
            emptyMessage="{{ person.name }} não realizou alterações de endereço"
          >
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th
                  *ngFor="let col of columns"
                  pReorderableColumn
                  pResizableColumn
                  [pSortableColumn]="col.field"
                >
                  {{ col.header }}
                  <p-sortIcon [field]="col.field" />
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-change let-columns="columns">
              <tr>
                <td
                  *ngFor="let col of columns"
                  [class.text-center]="isMobile && !col.showMobile"
                  [class.text-center]="col.type === 'link'"
                >
                  <span class="p-column-title" *ngIf="col.showMobile">{{
                    col.header
                  }}</span>
                  <ng-container *ngIf="col.type === 'text'">
                    {{ change[col.field] }}
                  </ng-container>
                  <ng-container *ngIf="col.type === 'date'">
                    {{ change[col.field] | date: 'dd/MM/yyyy HH:mm:ss' }}
                  </ng-container>
                  <ng-container *ngIf="col.type === 'link'">
                    <a
                      type="button"
                      [class.data-link]="change[col.field]"
                      (click)="
                        change.paymentId && showPayment(change.paymentId)
                      "
                    >
                      <ng-container *ngIf="change[col.field]">
                        <i
                          class="pi pi-credit-card"
                          style="font-size: 22px"
                        ></i>
                      </ng-container>
                      <ng-container *ngIf="!change[col.field]">
                        <i class="pi pi-times" style="color: red"></i>
                      </ng-container>
                    </a>
                  </ng-container>
                </td>
              </tr>
            </ng-template>
          </app-table>
        </p-tabPanel>
        <p-tabPanel [header]="'Estornos (' + (refunds?.length || 0) + ')'">
          <app-table
            [cols]="refundCols"
            [elements]="refunds"
            [actionButtons]="refundButtons"
            [lazy]="false"
            sortField="dateCreated"
            [sortOrder]="1"
            [exportPdf]="false"
            [exportExcel]="false"
            [showTitle]="false"
            [addButton]="false"
            [changeColumns]="true"
            (actionButtonClick)="callAction($event)"
            modelName="estornos"
            emptyMessage="{{ person.name }} não realizou estornos"
            *ngIf="refunds"
          />
        </p-tabPanel>
        <p-tabPanel [header]="'Cupons (' + (coupons?.length || 0) + ')'">
          <app-table
            [cols]="couponCols"
            [elements]="coupons"
            [lazy]="false"
            sortField="dateCreated"
            [sortOrder]="1"
            modelName="cupons utilizados"
            emptyMessage="{{ person.name }} não utilizou cupons"
            [exportPdf]="false"
            [exportExcel]="false"
            [showTitle]="false"
            [addButton]="false"
            [changeColumns]="true"
          />
        </p-tabPanel>
        <p-tabPanel
          [header]="'Cancelamentos (' + (cancellations?.length || 0) + ')'"
        >
          <app-table
            [cols]="cancellationCols"
            [elements]="cancellations"
            sortField="dateCancelled"
            [sortOrder]="1"
            [lazy]="false"
            [exportPdf]="false"
            [exportExcel]="false"
            [showTitle]="false"
            [addButton]="false"
            [changeColumns]="true"
            emptyMessage="{{ person.name }} não realizou cancelamentos"
            modelName="cancelamentos"
            *ngIf="cancellations"
          />
        </p-tabPanel>
        <p-tabPanel header="Envios">
          <ng-template pTemplate="content">
            <app-person-movements
              *ngIf="person.personId"
              [personId]="person.personId"
            />
          </ng-template>
        </p-tabPanel>
        <p-tabPanel header="Mudanças de status">
          <ng-template pTemplate="content">
            <app-table
              [cols]="statusLogCols"
              sortField="logDate"
              [sortOrder]="1"
              [lazy]="true"
              [exportPdf]="false"
              [exportExcel]="false"
              [showTitle]="false"
              [addButton]="false"
              [changeColumns]="true"
              emptyMessage="Assinatura sem alterações de status"
              modelName="mudanças"
              [service]="subscriberService"
              [findPage]="findStatusLogs"
              [dropdownFilters]="dropdownFilters"
              [fixedFilters]="[
                {
                  field: 'subscriberId',
                  value: subscriber.subscriberId,
                  condition: 'equals',
                  fieldType: 'number'
                }
              ]"
              [defaultFilterValues]="{
                oldStatus: null,
                newStatus: null
              }"
            />
          </ng-template>
        </p-tabPanel>
        <p-tabPanel header="Mudanças na recorrência">
          <ng-template pTemplate="content">
            <app-table
              [cols]="recurrenceLogCols"
              sortField="dateCreated"
              [sortOrder]="1"
              [lazy]="true"
              [exportPdf]="false"
              [exportExcel]="false"
              [showTitle]="false"
              [addButton]="false"
              [changeColumns]="true"
              emptyMessage="Assinatura sem mudanças na recorrência"
              modelName="mudanças"
              [service]="subscriberService"
              [findPage]="findRecurrenceStatusLogs"
              [dropdownFilters]="dropdownFilters"
              [fixedFilters]="[
                {
                  field: 'personId',
                  value: subscriber.personId,
                  condition: 'equals',
                  fieldType: 'number'
                }
              ]"
              [defaultFilterValues]="{
                oldLabel: null,
                newLabel: null
              }"
            />
          </ng-template>
        </p-tabPanel>
        <p-tabPanel header="Recorrências Pix">
          <ng-template pTemplate="content">
            <app-table
              [cols]="pixRecurrenceCols"
              [elements]="pixRecurrences"
              [lazy]="false"
              sortField="dateStart"
              [sortOrder]="1"
              modelName="recorrências"
              emptyMessage="{{ person.name }} não agendou pix"
              [exportPdf]="false"
              [exportExcel]="false"
              [showTitle]="false"
              [addButton]="false"
              [changeColumns]="true"
              [actionButtons]="pixRecurrenceActionButtons"
            />
          </ng-template>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</div>
<p-toast />
<p-confirmPopup *ngIf="!cancellationOpen" />
<p-confirmDialog />
